import { render, staticRenderFns } from "./AddPurchaseDialog.vue?vue&type=template&id=1ed9710c&scoped=true"
import script from "./AddPurchaseDialog.vue?vue&type=script&lang=js"
export * from "./AddPurchaseDialog.vue?vue&type=script&lang=js"
import style0 from "./AddPurchaseDialog.vue?vue&type=style&index=0&id=1ed9710c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed9710c",
  null
  
)

export default component.exports